module.exports = __webpack_public_path__ + "img/step3-t.e37d2bdb.png";